import React, { useEffect } from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { fetchCartList } from "../../actions/catalog";
import InfoBox from "../../components/Reusable/InfoBox";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import CartListItem from "./CartListItem";
import { t } from "i18next"; // Import t function for translation

const Cart = () => {
  const { cartList } = useSelector((state) => state.catalogReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCartList());
  }, [dispatch]);

  return (
    <div className="cart-main-container">
      <Breadcrumb title={t("cart.title")} returnPage="/" />

      <div className="cart-items-container">
        <div className="cart-list-container">
          {cartList?.length === 0 ? (
            <InfoBox text={t("cart.emptyCartMessage")} />
          ) : (
            <ul>
              <div className="product-list-items">
                {cartList?.map((product, key) => (
                  <CartListItem product={product} key={key} />
                ))}
              </div>
            </ul>
          )}
        </div>
      </div>
      {cartList?.length > 0 && (
        <div className="cart-item-button-checkout">
          <div className="cart-item-button-checkout-item">
            <Link to={"/checkout"}>
              <Button>{t("cart.checkoutButton")}</Button>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
